import { render, staticRenderFns } from "./SaIconButton.vue?vue&type=template&id=181d0cb4&"
import script from "./SaIconButton.vue?vue&type=script&lang=js&"
export * from "./SaIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports